// extracted by mini-css-extract-plugin
export default {"wrap":"Pagination_wrap__LW396","navBtn":"Pagination_navBtn__GfnrI","pageInfo":"Pagination_pageInfo__8Hb2j"};